import fetchHelpers from '@nhl/fetch-helpers';

const fetchPlayersByBirthday = args => {
    return fetchHelpers.doDefaultFetch(
        `/site/api/player/born/` +
        `?include=currentTeam.teamId` +
        `&include=currentTeam.triCode` +
        `&include={"path": "currentTeam.logos","cayenneExp":"startSeason <= ${args.season} and endSeason >= ${args.season}"}` +
        `&cayenneExp=birthMonth=${args.month} and birthDay=${args.day}`,
        args
    );
};

const fetchPlayersByTeamId = args => {
    return fetchHelpers.doDefaultFetch(
        `/site/api/player` +
        `?cayenneExp=currentTeam = ${args.teamId}` +
        `&include=id` +
        `&include=firstName` +
        `&include=lastName` +
        `&include=height` +
        `&include=weight` +
        `&include=birthDate` +
        `&include=birthCity` +
        `&include=birthStateProvince` +
        `&include=birthCountry` +
        `&include=sweaterNumber` +
        `&include=onRoster` +
        `&include=position.positionCode` +
        `&include=currentTeam.triCode` +
        `&include=currentTeam.logos` +
        `&include=pronunciation` +
        '&sort=[{"property": "lastName"}, {"property": "firstName"}]',
        args
    );
};

const fetchPlayersByTeamIdWithHeadshots = args => {
    return fetchHelpers.doDefaultFetch(
        `/site/api/player/withHeadshots/${args.seasonId}` +
        `?cayenneExp=currentTeam = ${args.teamId}` +
        `&include=id` +
        `&include=firstName` +
        `&include=lastName` +
        `&include=height` +
        `&include=weight` +
        `&include=birthDate` +
        `&include=birthCity` +
        `&include=birthStateProvince` +
        `&include=birthCountry` +
        `&include=sweaterNumber` +
        `&include=onRoster` +
        `&include=position.positionCode` +
        `&include=currentTeam.triCode` +
        `&include=currentTeam.logos` +
        `&sort=lastName`,
        args
    );
};

const getPlayerTotalsExp = (goalies, season) => {
    let totalsExpression = '';
    const totalsRelationship = goalies ? 'goalieTotals' : 'playerTotals';

    if (season) {
        totalsExpression = `${totalsRelationship}.season = ${season} and `
    }

    totalsExpression += `${totalsRelationship}.gamesPlayed > 0`;

    return { totalsExpression, totalsRelationship };
};

const getPlayerSearchIncludes = (totalsRelationship, season) => ([
    {
        path: totalsRelationship,
        cayenneExp: season !== null ? `season = ${season}` : null,
        sort: 'season',
        dir: 'DESC',
    },
    {
        [totalsRelationship]: [
            'team',
            'team.league',
            'team.logos',
            'season.id',
        ],
    },
    'position.positionCode',
]);

const searchPlayers = args => {
    const { totalsExpression, totalsRelationship } = getPlayerTotalsExp(args.goalies, args.season);
    const includeJson = getPlayerSearchIncludes(totalsRelationship, args.season);

    return fetchHelpers.doDefaultFetch(
        '/site/api/player' +
        `?cayenneExp=${args.search.split(/\s|,/).reduce((acc, q) => {
            if (acc !== '') {
                acc += ` and `
            }
            acc += `fullName likeIgnoreCase "%${q}%"`;
            
            return acc;
        }, '')}` +
        ` and position ${args.goalies ? '= "G"' : '!= "G"'}` +
        ` and ${totalsExpression}` +
        `&include=${JSON.stringify(includeJson)}`
    );
};

const getPlayerById = args => {
    const { totalsExpression, totalsRelationship } = getPlayerTotalsExp(args.goalies, args.season);
    const includeJson = getPlayerSearchIncludes(totalsRelationship, args.season);

    return fetchHelpers.doDefaultFetch(`/site/api/player` +
        `?cayenneExp=id=${args.playerId}` +
        ` and ${totalsExpression}` +
        `&include=${JSON.stringify(includeJson)}`
    );
};

export default {
    fetchPlayersByBirthday,
    fetchPlayersByTeamId,
    fetchPlayersByTeamIdWithHeadshots,
    searchPlayers,
    getPlayerById,
};
